import { render, staticRenderFns } from "./UDHtmlCell.vue?vue&type=template&id=2a49f31a&"
import script from "./UDHtmlCell.vue?vue&type=script&lang=js&"
export * from "./UDHtmlCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports